<template>
  <Drawer
    :id="drawerId"
    bottom
    height="75%"
  >
    <template #title>
      <v-icon
        class="mr-2 mt-n1"
        size="24"
      >
        mdi-email-arrow-right-outline
      </v-icon>
      Send to another account
    </template>
    <div class="px-6 pb-4">
      <div class="body-2 mb-4">
        Place a copy of this project into another person's account so they can edit it or order
        prints.
      </div>
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-text-field
          v-model="email"
          :rules="[$rules.required, $rules.email]"
          label="Recipient Email"
          placeholder="Recipient Email"
          persistent-placeholder
          outlined
        />

        <v-checkbox
          v-model="notifyRecipient"
          class="mt-0"
          hide-details
        >
          <template #label>
            <div class="body-2">Notify recipient via email</div>
          </template>
        </v-checkbox>
      </v-form>
    </div>

    <template #append>
      <v-divider />
      <div class="pa-5">
        <mcs-btn
          block
          large
          color="primary"
          :loading="sending"
          :disabled="!email"
          @click="send"
        >
          Send copy
          <v-icon class="ml-2">mdi-send-outline</v-icon>
        </mcs-btn>
      </div>
    </template>
  </Drawer>
</template>

<script>
import Drawer from '@/components/layout/Drawer';
import { DRAWERS } from '@/utils/constants';
import { mapGetters } from 'vuex';

export default {
  name: 'ShareToAccount',

  components: { Drawer },

  data() {
    return {
      drawerId: DRAWERS.SHARE_PROJECT_TO_ACCOUNT,
      email: '',
      notifyRecipient: true,
      sending: false,
      valid: false
    };
  },

  computed: {
    ...mapGetters({
      project: 'projects/selected',
      topDrawer: 'drawers/topDrawer',
      drawerOpenedAt: 'drawers/lastOpenedAt'
    })
  },

  watch: {
    drawerOpenedAt() {
      if (this.drawerId === this.topDrawer?.id) {
        this.reset();
      }
    }
  },

  methods: {
    reset() {
      this.email = '';
      this.notifyRecipient = true;
      this.sending = false;
      this.$refs.form?.resetValidation();
    },

    send() {
      if (!this.$refs.form.validate()) return;
      this.sending = true;
      this.$store
        .dispatch('projects/sendToAccount', {
          projectId: this.project.id,
          targetEmail: this.email,
          notifyRecipient: this.notifyRecipient
        })
        .then(() => {
          this.$root.$snackbarSuccess(`A copy was sent to ${this.email}.`);
          this.$store.commit('drawers/CLOSE_DRAWER', this.drawerId);
        })
        .catch((error) => {
          this.$root.$alert('Unable to send', error.message);
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }
};
</script>
